<template>
  <v-card min-height="600">
    <v-card-title>
      <span class="text-h5">Grafo distinta</span>
    </v-card-title>
    <v-card-text>
      <!-- <network ref="network" :nodes="nodes" :edges="edges" :options="options"/> -->
      <network ref="network" :options="options"/>
    </v-card-text>
  </v-card>  
</template>

<script>
  import * as Vue2vis from 'vue2vis'
  import _ from 'lodash'

  export default {
    components: {
     Network: Vue2vis.Network
    },
    props: {
      documento: Object,
      trigger: Number
    },    
    data () {
      return {
        nodes: [],
        edges: [],
        options: {
          autoResize: true,
          height: '500',
          width: '100%',
          locale: 'it', 
          layout: {
            hierarchical: {
              direction: 'LR',
              sortMethod: 'directed'
            }
          },
          nodes: {
            shape: 'box',
            chosen: false
          },
          configure: {
            enabled: false,
            showButton: false,
            filter: false
          },
          manipulation: {
            addNode: function (data, callback) {
              // filling in the popup DOM elements
              // document.getElementById("node-operation").innerText = "Add Node"
              // this.editNode(data, this.clearNodePopUp, callback)
            },
            editNode: function (data, callback) {
              // filling in the popup DOM elements
              // document.getElementById("node-operation").innerText = "Edit Node"
              // this.editNode(data, this.cancelNodeEdit, callback)
            },
            addEdge: function (data, callback) {
/*               if (data.from == data.to) {
                var r = confirm("Do you want to connect the node to itself?");
                if (r != true) {
                  callback(null)
                  return
                }
              }
              // document.getElementById("edge-operation").innerText = "Add Edge";
              this.editEdgeWithoutDrag(data, callback) */
            },
            editEdge: {
              editWithoutDrag: function (data, callback) {
                // document.getElementById("edge-operation").innerText = "Edit Edge"
                // this.editEdgeWithoutDrag(data, callback)
              }
            }
          }
/*           interaction:{
            dragNodes: false,
            dragView: false,
            hideEdgesOnDrag: false,
            hideEdgesOnZoom: false,
            hideNodesOnDrag: false,
            hover: false,
            hoverConnectedEdges: false,
            keyboard: {
              enabled: false
            },
            multiselect: false,
            navigationButtons: false,
            selectable: false,
            selectConnectedEdges: false,
            tooltipDelay: 300,
            zoomSpeed: 1,
            zoomView: true
          }   */        
        },
        distinta: [],
        itemId: 0,
        colori: {
          nota: '#d3d5ff',
          parametro: '#d7ffd3',
          prodotto: '#f3ffc9',
          multiselect: '#ffd3d3'
        },
        elaborazioneInCorso: false
      }
    },
    watch: {
      async documento(value) {
        // console.log('elaboraDistinta da documento0')
        await this.$nextTick()
        if (this.elaborazioneInCorso) return
        this.elaborazioneInCorso = true
        // console.log('elaboraDistinta da documento')
        await this.elaboraDistinta(1)
        this.elaborazioneInCorso = false
      },
      async trigger() {
        // console.log('elaboraDistinta da trigger0')
        await this.$nextTick()
        if (this.elaborazioneInCorso) return
        this.elaborazioneInCorso = true        
        // console.log('elaboraDistinta da trigger')
        await this.elaboraDistinta(1)
        this.elaborazioneInCorso = false
      }
    },
    async mounted() {
      // console.log('elaboraDistinta da mounted0')
      await this.$nextTick()
      if (this.elaborazioneInCorso) return
      this.elaborazioneInCorso = true
      // console.log('elaboraDistinta da mounted')
      await this.elaboraDistinta(1)
      this.elaborazioneInCorso = false
    },
    methods: {
      editNode(data, cancelAction, callback) {

      },
      clearNodePopUp() {

      },
      cancelNodeEdit(callback) {

      },
      saveNodeData(data, callback) {

      },
      editEdgeWithoutDrag(data, callback) {

      },
      clearEdgePopUp() {

      },
      cancelEdgeEdit(callback) {

      },
      saveEdgeData(data, callback) {

      },
      async elaboraDistinta(qta) {
        // leggere in base alla distinta selezionata
        this.itemId = 0
        if (!this.documento) return
        const codice = this.documento._id
        const distinta = this.documento.distinta
        this.edges = []
        const nodi = this.elaboraItemGrafo(distinta, qta, 0)
        // Object.assign(this.nodes, nodi)
        this.nodes = _.sortBy(nodi, ['livello', 'id'])
        const ntw = this.$refs['network']
        await ntw.setData(this.nodes, this.edges)
        await ntw.fit()
      },
      wordWrap(str, max, br = '\n') {
        return str.replace(
          new RegExp(`(?![^\\n]{1,${max}}$)([^\\n]{1,${max}})\\s`, 'g'), '$1' + br
        )
      },
      elaboraItemGrafo(item, qta = 1, livello) {
        if (!item || _.isEmpty(item)) return []
        let nodes = []
        if (item.items) {
          if (['prodotto', 'parametro'].includes(item.tipo)) {
            nodes.push({ id: item.id, label: `${this.wordWrap(item.descrizione, 20)} \n${item.valore || item.quantita} ${item.unitaMisura}`, color: this.colori[item.tipo] })
          } else {
            nodes.push({ id: item.id, label: `${this.wordWrap(item.descrizione, 20)}`, color: this.colori[item.tipo] })
          }
           for (let i of item.items) {
            this.edges.push({
              id: i.id, from: item.id, to: i.id
            })
            const totQta = qta * item.quantita
            nodes = nodes.concat(this.elaboraItemGrafo(i, totQta, livello + 1))
          }
        } else {
          if (['prodotto', 'parametro'].includes(item.tipo)) {
            nodes.push({ id: item.id, label: `${this.wordWrap(item.descrizione, 20)} \n${item.valore || item.quantita} ${item.unitaMisura}`, color: this.colori[item.tipo] })
          } else {
            nodes.push({ id: item.id, label: `${this.wordWrap(item.descrizione, 20)}`, color: this.colori[item.tipo] })
          }          
        }
        this.itemId++
        return nodes
      }
    }
  }
</script>

<style lang="scss">
  @import './vue2vis.css';

  .vis-button.vis-edit.vis-edit-mode {
    height: 25px !important;
  }
  .vis-edit-mode {
    display: none !important;
  }
</style>